import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { searchStaffFn } from 'api/org/per';
import { createFn } from 'api/org/dep';
import depTree from '@/components/dep-tree';
import { getAvatar } from '@/util/util';
var dataForm = {
  department_name: '',
  // 部门名称
  ancestry_id: '',
  // 上级部门id
  supervisor_id: '',
  // 负责人id
  ancestry_name: '' // 上级部门name
};

export default {
  props: ['state'],
  components: {
    depTree: depTree
  },
  data: function data() {
    return {
      info: {},
      visible: false,
      disabled: false,
      popover: false,
      selectLoading: false,
      supervisorOptions: [],
      dataForm: dataForm,
      dataRule: {
        department_name: [{
          required: true,
          message: this.$t('785')
        }],
        ancestry_id: [{
          required: true,
          message: this.$t('786')
        }],
        supervisor_id: [{
          required: true,
          message: this.$t('787')
        }]
      },
      parentNode: {}
    };
  },
  watch: {
    visible: function visible(v) {
      if (!v) {
        this.dataForm.ancestry_name = '';
        this.$refs.dataForm.resetFields();
      }
    }
  },
  methods: {
    // 生成员工头像姓名
    getAvatar: getAvatar,
    init: function init(info) {
      var _this = this;
      this.info = info;
      this.visible = true;
      this.dataForm = JSON.parse(JSON.stringify(dataForm));
      this.$nextTick(function () {
        _this.dataForm.ancestry_id = info.id;
        _this.dataForm.ancestry_name = info.department_name;
        _this.parentNode = info;
        _this.$nextTick(function () {
          return _this.$refs.dataForm.clearValidate();
        });
      });
    },
    handleNodeClick: function handleNodeClick(val) {
      this.dataForm.ancestry_name = val.department_name;
      this.dataForm.ancestry_id = val.department_id;
      this.parentNode = val;
      this.popover = false;
    },
    remoteMethod: function remoteMethod(query) {
      var _this2 = this;
      if (query !== '') {
        this.selectLoading = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          searchStaffFn({
            search_name: query,
            page_size: 20,
            data_privilege: 1
          }).then(function (res) {
            _this2.selectLoading = false;
            if (res && res.code === 1) {
              _this2.supervisorOptions = res.data.map(function (v) {
                return {
                  avatar_url: v.avatar_url,
                  staff_name: v.staff_name,
                  staff_name_secondary: v.staff_name_secondary,
                  staff_name_en: v.staff_name_en,
                  staff_id: v.staff_id
                };
              });
            }
          });
        }, 300);
      } else {
        this.supervisorOptions = [];
      }
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this3.disabled = true;
          createFn(_objectSpread(_objectSpread({}, _this3.dataForm), {}, {
            department_id: _this3.info.department_id
          })).then(function (res) {
            _this3.disabled = false;
            if (res && res.code === 1) {
              _this3.visible = false;
              _this3.$emit('refreshTreeList', {
                department_name: _this3.dataForm.department_name,
                department_id: res.data.department_id,
                is_sub_department: true
              }, _this3.parentNode);
              _this3.$message.success(res.message);
            }
          }).catch(function () {
            _this3.disabled = false;
          });
        }
      });
    }
  }
};